import { LoyaltyContext } from "@app/loyalty/context/LoyaltyContext";
import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";

export interface IBookingWhizzMemberProfileProps {}

export const BookingWhizzMemberProfile = ({}: IBookingWhizzMemberProfileProps) => {
    const { memberDetails } = useContext(LoyaltyContext);
    const { t } = useTranslation(["vendorLoyalty"]);

    return (
        <Fragment>
            <div className="w-full border-1 bg-gray-100 rounded p-4">
                <div className="flex">
                    <h1 className="font-bold text-xl">{memberDetails?.tierName}</h1>
                    <div className="self-center" style={{ marginLeft: "auto" }}>
                        <span className="p-1 text-sm bg-primary text-white rounded">{t("profile.tierBadge")}</span>
                    </div>
                </div>

                {memberDetails?.registerDate && (
                    <Fragment>
                        <hr className="my-4" />
                        <div className="w-full text-sm text-gray-500">
                            <p>
                                {t("profile.memberSince")}{" "}
                                {new Date(memberDetails.registerDate).toLocaleDateString(undefined, {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })}
                            </p>
                        </div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    );
};
